module.exports = __webpack_public_path__ + "img/cns_ios2.3794f84b.png";